module.exports = __webpack_public_path__ + "img/rule-content-ms.93c270d3.png";